<script lang="ts" setup>
import type { Button, Theme } from '~/types'
import type { RouteLocationRaw } from '#vue-router'

interface Props extends Button {
  inline?: boolean
  theme?: Theme
  secondary?: boolean
}
const props = defineProps<Props>()
const location = ref<RouteLocationRaw | string>('/')
onMounted(() => {
  location.value = getPage({ url: props.url, to: props.to, uid: props.uid })
})

const isExternal = computed(() => {
  return props.url?.startsWith('http') ?? props.url?.startsWith('www') ?? false
})
</script>

<template>
  <NuxtLink
    :to="location"
    :target="isExternal ? '_blank' : ''"
    class="uppercase tracking-wider font-medium group p-3 appear bbutton duration-200 inline-flex items-center rounded-xl"
    :class="[theme, { secondary: secondary }]"
  >
    <span class="min-w-26 md:min-w-32 lg:min-w-40 text-left">{{ text ? text : 'Click Here' }}</span>
    <Icon
      name="material-symbols:double-arrow"
      class="w-8 h-8 text-xl group-hover:animate-pulse ml-auto icon"
    />
  </NuxtLink>
</template>

<style lang="css" scoped>
@reference "@/assets/css/main.css";
.bbutton{
  @apply bg-primary text-white hover:bg-white hover:text-primary-dark font-semibold;
}
.light.bbutton, .secondary.bbutton{
  @apply bg-primary hover:bg-primary-dark text-zinc-50 hover:text-white;
}
.light.bbutton .icon{
  @apply text-primary-dark group-hover:text-primary-green
}
.light.bbutton.secondary{
  @apply bg-zinc-200 text-zinc-600 hover:bg-white hover:text-primary;
}
.light.bbutton.secondary .icon{
  @apply text-primary group-hover:text-zinc-600;
}
.dark.bbutton{
  @apply bg-primary text-white hover:bg-primary-dark;
}
.white.bbutton, .dark.secondary.bbutton{
  @apply bg-primary-dark text-zinc-100 hover:bg-white hover:text-primary-dark;
}
</style>
